import { render, staticRenderFns } from "./editPriceDialog.vue?vue&type=template&id=56dbdd37&scoped=true"
import script from "./editPriceDialog.vue?vue&type=script&lang=js"
export * from "./editPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dbdd37",
  null
  
)

export default component.exports